import { render, staticRenderFns } from "./SalaryLayout.vue?vue&type=template&id=5e9cfd4a&scoped=true&"
import script from "./SalaryLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./SalaryLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9cfd4a",
  null
  
)

export default component.exports